import { AGGREGATE_NAMES } from 'cpool-constants';
import type { SchemaUserResolver_GetAclPermissions } from 'cpool-tables/backend-resolvers';

import type { AssignedUsersLead } from './AssignedUserSlots';
import { ChangeAssignedUsersModal } from './ChangeAssignedUsersModal';
import { ChangeTriggerButton } from './ChangeTriggerButton';
import { useLeadAdvisers } from './useLeadAdvisers';

type Props = {
    iconOnly?: boolean;
    lead: AssignedUsersLead;
    permissions?: SchemaUserResolver_GetAclPermissions;
};

export const ChangeAssignedUsersButton: React.FC<Props> = ({ iconOnly = false, lead, permissions }) => {
    const { isError: advisersFailed } = useLeadAdvisers(lead);

    if (!lead.userIds.length || !permissions?.commands[AGGREGATE_NAMES.LOAN_REQUEST].changeAssignedUser) return null;

    return (
        <ChangeTriggerButton
            disabled={advisersFailed}
            iconOnly={iconOnly}
            renderModal={({ onClose, open }) => <ChangeAssignedUsersModal lead={lead} onClose={onClose} open={open} />}
            testId="change-assigned-users-button"
        />
    );
};
